"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

require("core-js/modules/es6.function.bind.js");

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _Text = _interopRequireDefault(require("./Text"));

var _createTypo = _interopRequireDefault(require("./createTypo"));

var _this = void 0;

var _default = function (Tag) {
  var _this2 = this;

  (0, _newArrowCheck2["default"])(this, _this);

  /**
   * Typography.Header
   * @description 分为 H1, H2, H3, H4, H5 不同的组件，表示不同层级，继承 Typography.Text API
   */
  var Header = function Header(props) {
    (0, _newArrowCheck2["default"])(this, _this2);
    return /*#__PURE__*/_react["default"].createElement(_Text["default"], (0, _extends2["default"])({}, props, {
      component: Tag,
      strong: true,
      isCode: false
    }));
  }.bind(this);

  Header.displayName = Tag.toUpperCase();
  var WrappedHeader = (0, _createTypo["default"])(Header, {
    limit: ["dark", "white", "primary"],
    defaultColor: "dark"
  }, {
    sizeMap: {
      h1: {
        size: "t8",
        lineHeight: "md"
      },
      h2: {
        size: "t7",
        lineHeight: "md"
      },
      h3: {
        size: "t6",
        lineHeight: "md"
      },
      h4: {
        size: "t5",
        lineHeight: "lg"
      },
      h5: {
        size: "t3",
        lineHeight: "lg"
      }
    },
    defaultSize: Tag,
    enableSizeProp: false
  }, "capitalize");
  return WrappedHeader;
}.bind(void 0);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/Typography/Header.js
// module id = 2073
// module chunks = 6 7 17 18